import React from 'react'
import * as Comp from './progress-indicator.styles'
import type { TProgressIndicatorProps } from './types'

export const ProgressIndicator = ({
  size = 'tiny',
  percentage = 0,
  duration,
  onComplete,
  bgTransparent = false,
  variant = 'brand',
  testID,
}: TProgressIndicatorProps) => {
  if (percentage !== 0 && duration) {
    throw new Error(
      "As propriedades 'percentage' e 'duration' são mutuamente exclusivas. Por favor, forneça apenas uma delas."
    )
  }

  const [currentPercentage, setCurrentPercentage] = React.useState(
    Math.min(Math.max(percentage, 0), 100)
  )

  React.useEffect(() => {
    setCurrentPercentage(Math.min(Math.max(percentage, 0), 100))
    if (percentage === 100 && onComplete) {
      onComplete()
    }
  }, [percentage, onComplete])

  React.useEffect(() => {
    if (duration) {
      const interval = duration / 100
      let progress = 0
      const intervalId = setInterval(() => {
        progress += 1
        setCurrentPercentage(prev => Math.min(Math.max(prev + 1, 0), 100))
        if (progress >= 100) {
          clearInterval(intervalId)
          onComplete?.()
        }
      }, interval)

      return () => clearInterval(intervalId)
    }
  }, [duration, onComplete])

  return (
    <Comp.Root
      size={size}
      bgTransparent={bgTransparent}
      testID={testID}
      role="progressbar"
      aria-valuenow={currentPercentage}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <Comp.Progress
        size={size}
        variant={variant}
        testID={`${testID}.progress`}
        style={{ width: `${currentPercentage}%` }}
      />
    </Comp.Root>
  )
}

export type { TProgressIndicatorProps }
